import { LoadingButton } from '@mui/lab';
import { Stack, TextField, Grid, Box, Switch, FormControlLabel, Divider } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { Button } from 'src/@/components/ui/button';
import { Textarea } from 'src/@/components/ui/textarea';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import v2_actionFinalizarMultiplosChats from 'src/actions/v2/chats/v2_actionFinalizarMultiplosChats';
import { RowInput } from 'src/components/forms/RowInput';
import Iconify from 'src/components/Iconify';
import InputStyleMultline from 'src/components/InputStyleMultline';
import TestInternetSpeed from 'src/components/TestInternetSpeed';
import { deleteAllCacheFiles } from 'src/helpers/cache.helper';


export default function Preferencias({
    checkedSomNotificacao,
    changeSomNotificacao,
    mensagemIntervalo,
    changeMensagemIntervalo,
    isModificado,
    changeIsModificado,
    onSubmit,
    user, 
    cliente
}) {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [loadingLimparChats, setLoadingLimparChats] = useState(false);


    async function limparChats() {
        try {
          let data = {
            usuarioId: user.id,
            status: 'Geral',
            clienteId: cliente._id,
    
          }
          setLoadingLimparChats(true)
          const result = await v2_actionFinalizarMultiplosChats(data);
          if (result.data.error) {
            setLoadingLimparChats(false)
            enqueueSnackbar('Erro ao finalizar chats', { variant: 'error' });
          }
          setLoadingLimparChats(false)
          enqueueSnackbar('Chats foram colcoados em fila para finalização. Essa ação pode demorar alguns minutos', { variant: 'success', autoHideDuration: 10000 });
        } catch (error) {
          setLoadingLimparChats(false)
          console.log(error);
          enqueueSnackbar('Erro ao limpar chats', { variant: 'error' });
    
        }
      }


    return (
        <Stack sx={{ maxWidth: '40%' }} spacing={2} direction="column">

            <h4 className='font-semibold'>Notificações</h4>
            <Stack spacing={3}>
                <FormControlLabel control={<Switch
                    checked={checkedSomNotificacao}
                    onChange={changeSomNotificacao
                    }
                    inputProps={{ 'aria-label': 'controlled' }}
                />} label="Som notificacao" />

            </Stack>
            <Divider sx={{ borderStyle: 'dashed' }} />


            <h4 className='font-semibold'>Mensagens</h4>

            <Stack spacing={3}>
                <RowInput
                    label={"Mensagem de intervalo"}
                    input={<Textarea
                        onChange={e => {
                            changeMensagemIntervalo(e);
                            changeIsModificado(true);

                        }}
                        value={mensagemIntervalo}
                        multiline rows={3} />}
                />
                 {isModificado && (
                    <ButtonLoading className="bg-slate-700" onClick={onSubmit}>
                        Salvar
                    </ButtonLoading>
                )}
            </Stack>
            <Divider sx={{ borderStyle: 'dashed' }} />

            <h4 className='font-semibold'>Sistema</h4>

            <div className='felx flex-col'>
                <Button 
                onClick={() => {
                    deleteAllCacheFiles();
                    enqueueSnackbar('Arquivos armazenados foram deletados', { variant: 'success' });
                }}
                className="bg-red-50 text-red-900 items-center hover:bg-red-200"
                >
                    <Iconify icon="fluent:delete-20-regular" className="icon-arrow-up mr-2" />
                    Limpar arquivos em cache
                </Button>
            </div>


            <div className='felx flex-col'>
            <ButtonLoading className="bg-red-100" variant='secondary' onClick={limparChats} loading={loadingLimparChats}>
            <Iconify icon="fluent:delete-20-regular" className="icon-arrow-up mr-2" />
            Limpar chats "No Bot"
            </ButtonLoading>
          </div>



        </Stack>
    );
}
